import { render, staticRenderFns } from "./edit-variant.vue?vue&type=template&id=51e1ad06&"
import script from "./edit-variant.vue?vue&type=script&lang=js&"
export * from "./edit-variant.vue?vue&type=script&lang=js&"
import style0 from "./edit-variant.vue?vue&type=style&index=0&id=51e1ad06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports